// Mock data for Market Street Ventures clone

export const company = {
  name: "Market Street Ventures",
  tagline: "A holding company with three independent business units.",
  phone: "(832) 631-6111",
  phoneRaw: "8326316111",
  email: "info@marketstreetventures.com",
  address: {
    line1: "9595 Six Pines Dr., Ste. 8210",
    line2: "The Woodlands, TX 77382",
  },
};

export const navLinks = [
  { label: "Drying Agent / Absorbent", path: "/absorbent" },
  { label: "Spill Solutions", path: "/spill-solutions" },
  { label: "Pinkwater®", path: "/pinkwater" },
  { label: "Cleaning Solutions", path: "/cleaning-solutions" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export const heroSlides = [
  {
    id: 1,
    kicker: "Market Street Ventures",
    title: "Cleaning Solutions",
    cta: "View Products",
    ctaPath: "/cleaning-solutions",
    image:
      "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  },
  {
    id: 2,
    kicker: "Market Street Ventures",
    title: "Absorbent",
    cta: "View Products",
    ctaPath: "/absorbent",
    image:
      "https://images.pexels.com/photos/236698/pexels-photo-236698.jpeg?auto=compress&cs=tinysrgb&w=2000",
  },
  {
    id: 3,
    kicker: "Market Street Ventures",
    title: "Surfactants",
    cta: "View Products",
    ctaPath: "/cleaning-solutions",
    image:
      "https://images.pexels.com/photos/4883682/pexels-photo-4883682.jpeg?auto=compress&cs=tinysrgb&w=2000",
  },
];

export const businessUnits = [
  {
    id: 1,
    number: "01",
    name: "Market Street Oil and Gas",
    short: "Oil & Gas",
    description:
      "Focused on oil & gas commodities, supplying and brokering with reliability, integrity and long-term partnerships.",
  },
  {
    id: 2,
    number: "02",
    name: "Market Street Print and Promotion",
    short: "Print & Promotion",
    description:
      "The cornerstone of the Market Street Ventures brand. A one-stop source for all of your printing, promotional, graphic design and website design needs.",
  },
  {
    id: 3,
    number: "03",
    name: "Market Street Consulting and Brokerage Services",
    short: "Consulting & Brokerage",
    description:
      "Providing solutions that improve business processes, directly reflected in the bottom line of our clients across a range of industries.",
  },
  {
    id: 4,
    number: "04",
    name: "Market Street Commodities",
    short: "Commodities",
    description:
      "Sourcing and distributing quality commodities, maximizing value while lowering costs and reducing turnaround time.",
  },
  {
    id: 5,
    number: "05",
    name: "Buried Lie Consulting",
    short: "Buried Lie Consulting",
    description:
      "Specialized consulting services helping clients navigate complex challenges and reach their goals and objectives.",
  },
];

export const aboutContent = {
  heading: "About Market Street Ventures",
  image:
    "https://images.pexels.com/photos/37320179/pexels-photo-37320179.jpeg?auto=compress&cs=tinysrgb&w=2000",
  overview:
    "Market Street Ventures (MSV) is a privately held company headquartered in The Woodlands, Texas, specializing in the development, marketing, and distribution of innovative industrial products and business solutions. Through its focused portfolio of specialty brands, MSV serves commercial, industrial, energy, transportation, aviation, marine, and emergency response markets with products engineered to improve safety, operational efficiency, and environmental performance.",
  hq: {
    name: "Market Street Ventures",
    line1: "9595 Six Pines Drive, Suite 8210",
    line2: "The Woodlands, TX 77380",
    phone: "(832) 631-6111",
    phoneRaw: "8326316111",
  },
  coreBusinessAreas: [
    {
      icon: "Droplets",
      title: "BoneDry® Absorbent Products",
      desc: "High-performance absorbent solutions designed for hydrocarbon, chemical, water, and general spill response. BoneDry products deliver superior absorbency, reduced waste, and safer cleanup across industrial facilities, transportation fleets, aviation operations, marine environments, and emergency response applications.",
    },
    {
      icon: "FlaskConical",
      title: "Surfactants & Specialty Chemicals",
      desc: "Advanced cleaning technologies and environmentally responsible surfactants that improve cleaning efficiency, spill remediation, and environmental compliance for industrial and commercial operations.",
    },
    {
      icon: "Megaphone",
      title: "Branding & Promotional Solutions",
      desc: "Strategic branding, marketing collateral, promotional products, and corporate identity solutions that help organizations strengthen brand recognition and support business growth.",
    },
  ],
  mission:
    "At Market Street Ventures, our mission is to deliver innovative, cost-effective products that enhance workplace safety, environmental stewardship, and operational performance. We are committed to building long-term partnerships by providing exceptional customer service, dependable solutions, and products that create measurable value for our customers.",
  industries: [
    "Industrial Manufacturing",
    "Oil & Gas",
    "Transportation & Trucking",
    "Aviation",
    "Marine & Port Operations",
    "Construction",
    "Municipal & Public Works",
    "Fire Departments & Emergency Response",
    "Commercial Facilities",
    "Environmental Remediation",
  ],
  portfolio: [
    {
      icon: "Droplets",
      name: "BoneDry Premium Drying Agent",
      desc: "A premium, multi-purpose absorbent engineered to rapidly absorb oils, fuels, chemicals, coolants, water, and other industrial liquids. Available in multiple package configurations to meet the needs of industrial facilities, transportation fleets, municipalities, contractors, and emergency response professionals.",
    },
    {
      icon: "Beaker",
      name: "Pinkwater® Surfactants",
      desc: "Specialized surfactant technology formulated to improve industrial cleaning, spill mitigation, hydrocarbon remediation, and environmental performance across a wide range of commercial and industrial applications.",
    },
  ],
  advantages: [
    "Innovative, solution-driven industrial product portfolio",
    "Commitment to safety, sustainability, and environmental responsibility",
    "High-performance products engineered for demanding industrial applications",
    "Responsive customer service and technical support",
    "Strategic branding and product development expertise",
    "Long-term partnerships built on integrity, quality, and reliability",
  ],
  closing: {
    heading: "Building Solutions That Perform",
    text: "Market Street Ventures combines innovation, technical expertise, and customer-focused service to deliver products that solve real-world challenges. Whether supporting industrial maintenance, spill response, environmental remediation, or brand development, our commitment remains the same — providing reliable solutions that help our customers operate more safely, efficiently, and successfully.",
  },
};

export const cleaningContent = {
  header: "Professional Grade Detergents & Cleaning Solutions",
  headerImage:
    "https://images.pexels.com/photos/32520873/pexels-photo-32520873.jpeg?auto=compress&cs=tinysrgb&w=2000",
  lead:
    "Market Street Ventures is a seller of professional grade disinfectants, sanitizers, detergents, and cleaning solutions.",
  paragraphs: [
    "GC-2100 & GC-2010: Market Street Ventures offers ready to use GC-2100, and the concentrate GC-2010, both of which are listed on the EPA's Registered Antimicrobial Products for use against the novel Coronavirus SARS-CoV-2, the cause of COVID-19. MSV currently sells both products to Health Care Facilities, Hospitals, Institutional Kitchens, Restaurants, USDA Inspected Food Processing Facilities, Athletic Facilities, Colleges, Correctional Facilities, Hotels, Schools, Airports, Retail Stores, Commercial Properties, and more.",
    "In addition, MSV is a seller of Floor Care Products, Air Care Products, Hand & Body Soaps, Antiseptic Soaps, Carpet Care & Upholstery Cleaners, Disinfectants / Sanitizers, General Cleaning, Industrial Cleaners, Restroom Cleaners, Nature's Way environmentally formulated products, Laundry Care, Food Service, Food Processing Cleaners, and more.",
  ],
};

export const cleaningBrands = [
  {
    id: "jansan",
    name: "Syntec Jan-San",
    logo: "/brands/jansan.png",
    products: [
      "All-Purpose Cleaners",
      "Refresh Air Care",
      "Bathroom Cleaners",
      "Brewery Cleaners",
      "Carpet Care",
      "Cleanzyme Enzymatic Cleaners",
      "Disinfectants & Sanitizers",
      "EZ Fill System Core 24",
      "Floor Care",
      "Food Processing",
      "Food Service",
      "Green Clean",
      "Hand & Body",
      "Industrial Cleaners",
      "Laundry Detergents",
      "Portable Restroom Cleaners",
      "Stone Care & Restoration",
      "Squeeze & Pour",
    ],
  },
  {
    id: "proclean",
    name: "ProClean",
    logo: "/brands/proclean.png",
    products: [
      "Vehicle & Transportation Cleaners",
      "Pressure Wash & Equipment Cleaning",
      "Concrete & Asphalt Cleaners",
      "Graffiti Removal",
    ],
  },
  {
    id: "tricore",
    name: "Tricore",
    logo: "/brands/tricore.png",
    products: [
      "Fire, Water & Mold Restoration",
      "Detoxifiers",
      "Mold Removers",
      "Organic Destroyers",
      "Smoke & Odor Removers",
      "Surface & Wall Cleaners",
    ],
  },
  {
    id: "ecowash",
    name: "EcoWash",
    logo: "/brands/ecowash.png",
    products: [
      "House Washing Detergents",
      "Roof Washing Detergents",
      "Concrete Restoration",
      "Wood Restoration",
    ],
  },
  {
    id: "patriot",
    name: "Patriot",
    logo: "/brands/patriot.png",
    products: [
      "Laundry Detergents",
      "Dishwashing Products",
      "Ware Washing Products",
      "Fire Safety Laundry Detergents",
    ],
  },
];

export const absorbentContent = {
  header: "Premium Drying Agents & Absorbents",
  headerImage:
    "https://images.unsplash.com/photo-1562237553-36ad661d6f2c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  lead:
    "BoneDry™ is a superior drying agent without limitation — extraordinary holding power for cleaning up spills of any oil or water based liquids, on any hard surface, in any industry.",
  paragraphs: [
    "QUICKLY ABSORBS ANY OIL OR WATER-BASED LIQUID SPILLS ON A HARD SURFACE. When it comes to quickly and cost-effectively cleaning up spills and leaks, BoneDry™ delivers a level of performance you may not have thought possible. With BoneDry's extraordinary holding power, you can clean up virtually any spill — on any surface, in any industry, and at a competitive price.",
  ],
  stats: [
    { value: "15x", label: "More Absorbent than Clay or Conventional Absorbents" },
    { value: "50%", label: "Savings Compared to Clay" },
    { value: "Up to 75%", label: "Reduced Disposal Costs vs. Clay (BoneDry™ HC)" },
  ],
  features: [
    { title: "Extraordinary Holding Power", text: "Cleans up spills of any oil or water based liquid, on any hard surface, in any industry." },
    { title: "15x More Absorbent", text: "Highest absorption rate compared to conventional clay-based products — use far less product." },
    { title: "Minimizes Waste", text: "Weighs less and absorbs more than most competitive absorbents. Less product, less tonnage, less cost." },
    { title: "Safe Disposal", text: "Can be safely disposed of in landfills. Non-biodegradable and non-leaching." },
  ],
};

export const boomsContent = {
  eyebrow: "For Water Spills",
  title: "Unsinkable Oil Absorbent Socks & Booms",
  subtitle: "The best absorbent for oil spills in any body of water.",
  features: [
    {
      icon: "LifeBuoy",
      title: "Unsinkable",
      text: "Our booms and socks will never sink.",
    },
    {
      icon: "ShieldCheck",
      title: "Heavy-Duty Construction",
      text: "Reinforced webbing and stainless steel hardware built to withstand strong river currents and choppy ocean seas.",
    },
    {
      icon: "Droplets",
      title: "Super Absorbent",
      text: "Absorbs oils, fuels, lubricants, and hydrocarbons only — not water.",
    },
    {
      icon: "Leaf",
      title: "Environmentally Conscious",
      text: "Made from organic, recycled, and biodegradable components.",
    },
  ],
  sizes: [
    {
      name: "Socks",
      image: "/bonedry/sock-hq.jpg",
      spec: '3" diameter, 4\u2032 length (30/case)',
      text: "Each premium-quality sock absorbs more than 1/2 gallon of oil. No external jacket or hardware.",
    },
    {
      name: "Booms",
      image: "/bonedry/boom-hq.jpg",
      spec: '5" diameter, 10\u2032 length (4/bundle)',
      text: "Each boom absorbs more than 10 gallons of oil. Features heavy-duty stainless steel rings and clips and a strong nylon mesh jacket.",
    },
    {
      name: "Bilge Mini-Booms",
      image: "/bonedry/miniboom-hq.jpg",
      spec: '5" diameter, 15\u2032 length (30/case)',
      text: "Perfect for absorbing small engine leaks and spills before they can be pumped overboard. Nylon mesh jacket and eye-loop for durability and easy retrieval.",
    },
  ],
  heroImage: "/bonedry/booms-hero.jpg",
};


export const boneDryProducts = [
  {
    id: "all",
    name: "BoneDry™ All",
    logo: "/bonedry/all.png",
    image: "/bonedry/all-product.jpg",
    badge: "Super-Absorbent",
    banner: "15X More Absorbent Than Clay",
    punch: "A Little Bit Goes a Long Way — Instant Spill Control",
    absorbs: ["Oil", "Fuel", "Coolant", "Brake Fluid", "Paint", "Water-Based"],
    highlights: [
      "Extraordinary holding power",
      "Spills of any oil or water base liquids",
      "Any surface",
      "Any industry",
    ],
    pillars: [
      {
        icon: "Droplets",
        title: "Maximum Absorbency",
        text: "15X more absorbent than clay. Absorbs on contact and is non-leaching.",
      },
      {
        icon: "ShieldCheck",
        title: "Enhanced Safety",
        text: "Non-toxic, non-abrasive and safe for all floor types. Helps reduce slip-and-fall hazards.",
      },
      {
        icon: "Settings",
        title: "Unmatched Versatility",
        text: "Absorbs oil, fuel, coolants, chemicals, water and more. One product, countless applications.",
      },
    ],
    packaging: [
      {
        name: "2 Cubic Foot Bag",
        tag: "Best for High-Volume Applications",
        image: "/bonedry/pkg-2cf.png",
        points: [
          "Maximum value",
          "Covers large areas quickly",
          "Ideal for stocking maintenance departments",
          "Industrial plants & large spill response",
        ],
      },
      {
        name: "3 lb Resealable Bag",
        tag: "Spill Response Ready",
        image: "/bonedry/pkg-3lb.png",
        points: [
          "Resealable, lightweight & easy to carry",
          "Convenient storage",
          "Perfect for vehicles, tools & emergency kits",
          "Ready whenever you need it",
        ],
      },
      {
        name: "Super Sacks",
        tag: "Bulk Industrial Supply",
        image: "/bonedry/pkg-supersack.png",
        points: [
          "Reduced packaging waste & lower cost per pound",
          "Efficient bulk storage",
          "Compatible with bulk handling equipment",
          "Refineries, ports, rail & distribution centers",
        ],
      },
    ],
    applications: [
      { icon: "Car", label: "Garages & Auto Shops" },
      { icon: "Truck", label: "Fleet Maintenance" },
      { icon: "Factory", label: "Industrial Facilities" },
      { icon: "Cog", label: "Manufacturing Plants" },
      { icon: "Warehouse", label: "Warehouses & Distribution" },
      { icon: "HardHat", label: "Construction Sites" },
      { icon: "Landmark", label: "Municipal Operations" },
      { icon: "Siren", label: "Emergency Response" },
    ],
    tagline:
      "Extraordinary holding power for cleaning spills of any oil or water base liquids, on any hard surface, in any industry.",
    intro:
      "When it comes to quickly and cost-effectively cleaning up spills and leaks, BoneDry™ All Absorbent delivers a level of performance you may not have thought possible. With its extraordinary holding power, you can clean up virtually any spill — on any surface, in any industry, at a competitive price.",
    points: [
      "Whether your spill is oil or water based, BoneDry™ All is up to the task — the major weapon in your cleanup arsenal.",
      "Typically 15 times more absorbent than conventional clay-based products, resulting in far less product used — typically a 50% savings while delivering superior performance.",
      "Amazing encapsulation properties turn spilled polymers and coagulants into a dry, fluffy substance.",
      "Significantly minimizes waste because it weighs less and absorbs more than most competitive absorbents.",
      "Can be safely disposed of in landfills (Non-biodegradable, Non-leaching).",
    ],
  },
  {
    id: "hc",
    name: "BoneDry™ HC",
    logo: "/bonedry/hc.png",
    tagline:
      "Premium drying agent for the solidification, haul off, and disposal of oil based mud cuttings.",
    intro:
      "Now cleaning up oil spills can be done quickly, easily, and cost-effectively — all you need is BoneDry™ HC Absorbent and a broom! Upon contact, it instantly absorbs, encapsulates, and never lets go of any type of oil spill on soil, grass and all solid surfaces. Effective on diesel fuel, lubricants, hydraulic fluid, brake fluid, transmission fluid, drilling fluid, oil-based mud cuttings and many others.",
    points: [
      "Instantly absorbs any and all hydrocarbons on soil, grass, and solid surfaces.",
      "Typically 10 times more absorbent than conventional clay-based products — use less product, typically a 50% savings.",
      "Will not absorb water — removes oils but leaves the water behind, ideal for cleaning up oil spills in wet environments.",
      "The perfect drying agent for closed loop solids control.",
      "Can be safely disposed of in landfills and reduces disposal costs by up to 75% compared to clay.",
    ],
  },
  {
    id: "sc",
    name: "BoneDry™ SC",
    logo: "/bonedry/sc.png",
    tagline:
      "Removes spent caustic drips and spills around pumps, truck loading/unloading, tank bottoms, fittings, and sample collection.",
    intro:
      "BoneDry™ SC minimizes and/or removes hazardous odors associated with sulfides, mercaptans, volatiles, and semi-volatiles. It becomes encapsulated in the absorbent and will not release once fully absorbed, and will pass leaching and paint tests for landfill disposal. Very user friendly, it eliminates hazardous conditions and the need to apply oxidizers such as hypochlorite or hydrogen peroxide.",
    points: [
      "Whether your spill is oil or water based, BoneDry™ SC is up to the task.",
      "Typically 10 times more absorbent than conventional clay-based products — typically a 50% savings while delivering superior performance.",
      "Amazing encapsulation properties turn spilled polymers and coagulants into a dry, fluffy substance.",
      "Eliminates hazardous & corrosive surfaces which can be dangerous to health and destructive to the environment.",
      "Significantly minimizes waste; can be safely disposed of in landfills (Non-biodegradable, Non-leaching).",
    ],
  },
  {
    id: "h2o",
    name: "BoneDry™ H2O",
    logo: "/bonedry/h2o.png",
    tagline:
      "Extraordinarily efficient drying agent designed for the solidification (mixing off) of water-based mud cuttings produced in oil & gas horizontal directional drilling.",
    intro:
      "Efficient and effective, BoneDry™ H2O Absorbent maximizes savings by minimizing usage, which leads to additional cost savings at the landfill. It delivers a level of performance you may not have thought possible.",
    points: [
      "Should be the major weapon used to solidify water-based mud cuttings.",
      "Typically 10 times more absorbent — use far less product to solidify cuttings, typically a 50% savings.",
      "Fully encapsulates water based mud cuttings, ensuring all loads are dry and not turned away at the landfill.",
      "Significantly minimizes waste — less product means less tonnage, less waste, less cost.",
      "Can be safely disposed of in landfills (Non-biodegradable, Non-leaching).",
    ],
  },
  {
    id: "crime",
    name: "BoneDry™ Crime",
    logo: "/bonedry/crime.png",
    tagline:
      "Rapid encapsulation and solidification of blood and biohazardous fluids for safe crime-scene, trauma, and biohazard cleanup.",
    intro:
      "BoneDry™ Crime is engineered for crime-scene, trauma, and biohazard remediation. On contact it instantly absorbs and encapsulates blood and other potentially infectious bodily fluids, transforming hazardous liquids into a dry, manageable solid that can be safely collected, bagged, and disposed of — helping reduce exposure risk for first responders, remediation crews, and law enforcement.",
    points: [
      "Instantly absorbs and encapsulates blood and biohazardous fluids on hard and porous surfaces.",
      "Locks liquids into a dry, non-leaching solid for safe handling, bagging, and disposal.",
      "Helps minimize cross-contamination and exposure to bloodborne pathogens during cleanup.",
      "Fast application using minimal product — supporting quicker scene turnover and lower cost.",
      "Ideal for law enforcement, crime-scene cleanup companies, EMS, and biohazard remediation teams.",
    ],
  },
  {
    id: "fg",
    name: "BoneDry™ FG",
    logo: "/bonedry/fg.png",
    tagline:
      "Food-grade super absorbent for the rapid, complete removal of spills in foodservice, hospitality, healthcare, and food processing.",
    intro:
      "Compatible with virtually any oil or water-based substance, BoneDry™ FG Absorbent outperforms conventional absorbents like clay, vermiculite, and other granular materials. Made with FDA-recognized ingredients, it is safe to use in healthcare and food processing environments — quickly picking up foods, oils, detergents, or waste products while leaving a non-slip, residue-free surface that helps minimize costly slip-and-fall injuries.",
    points: [
      "Super absorbent — holds up to 12 times its weight for rapid, complete spill removal.",
      "Made with FDA-recognized ingredients; safe for healthcare and food processing environments.",
      "Leaves a non-slip, residue-free surface to reduce the risk of slips and falls.",
      "Suppresses odors and vapors; non-toxic, non-abrasive, non-leaching, and non-hazardous.",
      "10x more effective than conventional absorbents — typically 50% savings versus clay.",
      "Lightweight and easy to handle.",
    ],
    skus: [
      { sku: "BD-FG-J", description: "164 oz. Plastic Jug" },
      { sku: "BD-FG-12", description: "Bag-in-a-box" },
      { sku: "BD-FG-25", description: "25 Gallon Poly Drum" },
    ],
  },
];

export const spillContent = {
  brand: "Market Street Ventures",
  kicker: "Market Street Ventures",
  title: "Comprehensive Spill Solutions",
  headerImage:
    "https://images.pexels.com/photos/32520873/pexels-photo-32520873.jpeg?auto=compress&cs=tinysrgb&w=2000",
  positioning:
    "Market Street Ventures is your Complete Spill Prevention & Environmental Solutions Provider. Rather than simply supplying absorbents, we partner with you across the entire spill lifecycle — assessment, prevention, response, training, and compliance — shifting the conversation from price per bag to measurable value, expertise, and peace of mind.",
  subPositioning:
    "The most valuable partnerships solve real operational problems, not just move product. Through ongoing programs, scheduled service, and hands-on expertise, we help you reduce risk, stay compliant, and control costs — building long-term relationships that deliver recurring value on both sides.",
};

// icon = lucide-react icon name mapped in the page component
export const spillServices = [
  {
    id: 1,
    icon: "Siren",
    title: "Spill Response Programs",
    items: [
      "Emergency spill response contracts",
      "On-site spill kit inspections and replenishment",
      "Industrial spill preparedness assessments",
      "Spill response training for employees",
    ],
    customers: "Manufacturing, trucking, municipalities, oil & gas, utilities, warehouses",
  },
  {
    id: 2,
    icon: "Waves",
    title: "Stormwater & Water Management",
    items: [
      "Flood mitigation services",
      "Standing water cleanup",
      "Construction site dewatering",
      "Soil stabilization using absorbents",
      "Erosion control consulting",
    ],
    customers: "Contractors, DOTs, municipalities, developers",
  },
  {
    id: 3,
    icon: "ClipboardCheck",
    title: "Environmental Compliance",
    items: ["Spill prevention planning"],
    customers: "",
  },
  {
    id: 4,
    icon: "Flame",
    title: "Fire Department Services",
    items: [
      "Hydrocarbon spill cleanup support",
      "Vehicle accident cleanup supplies",
      "Fire station spill kit management",
      "PFAS-free absorbent recommendations",
      "Training on absorbent deployment",
    ],
    customers: "",
  },
  {
    id: 5,
    icon: "Truck",
    title: "Fleet Maintenance Programs",
    intro: "Offer scheduled deliveries for:",
    items: [
      "Pinkwater surfactant",
      "Oil absorbents",
      "Fuel spill products",
      "Shop floor absorbents",
      "Degreasers",
      "Spill kits",
    ],
    customers: "",
  },
  {
    id: 6,
    icon: "HardHat",
    title: "Construction Site Services",
    items: [
      "Mud control",
      "Wet soil drying",
      "Concrete washout management",
      "Fuel spill containment",
      "Daily site absorbent replenishment",
    ],
    customers: "",
  },
  {
    id: 7,
    icon: "Factory",
    title: "Oil & Gas",
    items: [
      "Solids Control",
      "Spills",
      "Oil based Mud",
      "Water based Mud",
      "Rig Wash products",
    ],
    customers: "",
  },
  {
    id: 8,
    icon: "Package",
    title: "Spill Kit Management",
    intro: "A subscription-based service that includes:",
    items: ["Restocking", "Expired product replacement"],
    customers: "",
  },
  {
    id: 9,
    icon: "GraduationCap",
    title: "Training Services",
    intro: "Offer certification-style classes on:",
    items: [
      "Spill response",
      "OSHA spill procedures",
      "Environmental compliance",
      "Stormwater BMPs",
      "Hazardous material awareness",
    ],
    footnote: "Training often leads to product sales.",
    customers: "",
  },
  {
    id: 10,
    icon: "FlaskConical",
    title: "Custom Absorbent Solutions",
    intro: "Consult with customers to determine:",
    items: [
      "Best absorbent for the application",
      "Cost-per-spill analysis",
      "Waste reduction",
      "Disposal recommendations",
      "Product demonstrations",
    ],
    customers: "",
  },
];

export const industriesServed = [
  "Fire Departments",
  "Public Works",
  "Municipalities",
  "DOTs",
  "Oil & Gas",
  "Manufacturing",
  "Chemical Plants",
  "Food Processing",
  "Warehouses",
  "Distribution Centers",
  "Trucking Companies",
  "Construction Contractors",
  "Marinas",
  "Airports",
  "Railroads",
  "Mining Operations",
];

export const roiOpportunities = [
  "Monthly spill kit inspections",
  "Automatic absorbent replenishment",
  "Facility safety audits",
  "Fleet wash and absorbent programs",
  "Construction site service contracts",
  "Fire department readiness programs",
  "Environmental compliance inspections",
];

// Pool of products & service solutions used by the Industries explorer.
// icon = lucide-react icon name mapped in the component. type = "Product" | "Service".
export const solutionsPool = {
  "bonedry-all": {
    name: "BoneDry™ All Absorbent",
    type: "Product",
    icon: "Droplets",
    desc: "Universal drying agent for oil or water-based spills on any hard surface.",
    link: "/absorbent",
  },
  "bonedry-hc": {
    name: "BoneDry™ HC",
    type: "Product",
    icon: "Fuel",
    desc: "Hydrocarbon absorbent for oil spills and oil-based mud cuttings.",
    link: "/absorbent",
  },
  "bonedry-sc": {
    name: "BoneDry™ SC",
    type: "Product",
    icon: "FlaskConical",
    desc: "Removes spent caustic drips and neutralizes hazardous odors.",
    link: "/absorbent",
  },
  "bonedry-h2o": {
    name: "BoneDry™ H2O",
    type: "Product",
    icon: "Waves",
    desc: "Solidifies water-based mud cuttings for clean landfill disposal.",
    link: "/absorbent",
  },
  cleaning: {
    name: "Professional Cleaning Solutions",
    type: "Product",
    icon: "SprayCan",
    desc: "Disinfectants, sanitizers, degreasers and detergents for every facility.",
    link: "/cleaning-solutions",
  },
  "spill-response": {
    name: "Spill Response Programs",
    type: "Service",
    icon: "Siren",
    desc: "Emergency response contracts, preparedness assessments and training.",
    link: "/spill-solutions",
  },
  stormwater: {
    name: "Stormwater & Water Management",
    type: "Service",
    icon: "CloudRain",
    desc: "Flood mitigation, dewatering, soil stabilization and erosion control.",
    link: "/spill-solutions",
  },
  compliance: {
    name: "Environmental Compliance",
    type: "Service",
    icon: "ClipboardCheck",
    desc: "Spill prevention planning to keep your operation audit-ready.",
    link: "/spill-solutions",
  },
  "fire-dept": {
    name: "Fire Department Services",
    type: "Service",
    icon: "Flame",
    desc: "Hydrocarbon cleanup, accident supplies and PFAS-free recommendations.",
    link: "/spill-solutions",
  },
  fleet: {
    name: "Fleet Maintenance Programs",
    type: "Service",
    icon: "Truck",
    desc: "Scheduled deliveries of absorbents, degreasers and spill kits.",
    link: "/spill-solutions",
  },
  construction: {
    name: "Construction Site Services",
    type: "Service",
    icon: "HardHat",
    desc: "Mud control, wet soil drying, washout management and containment.",
    link: "/spill-solutions",
  },
  "oil-gas-svc": {
    name: "Oil & Gas Solids Control",
    type: "Service",
    icon: "Factory",
    desc: "Solids control, spill response, and rig wash products.",
    link: "/spill-solutions",
  },
  "spill-kit": {
    name: "Spill Kit Management",
    type: "Service",
    icon: "Package",
    desc: "Subscription restocking, inspections and expired product replacement.",
    link: "/spill-solutions",
  },
  training: {
    name: "Training Services",
    type: "Service",
    icon: "GraduationCap",
    desc: "Certification-style classes on spill response and OSHA procedures.",
    link: "/spill-solutions",
  },
  custom: {
    name: "Custom Absorbent Solutions",
    type: "Service",
    icon: "Settings",
    desc: "Application analysis, cost-per-spill review and product demos.",
    link: "/spill-solutions",
  },
};

export const industriesData = [
  {
    name: "Oil & Gas",
    icon: "Fuel",
    blurb: "Solids control, drill-cuttings solidification and rapid spill response for upstream and midstream operations.",
    solutions: ["oil-gas-svc", "bonedry-hc", "bonedry-h2o", "bonedry-sc", "spill-response"],
  },
  {
    name: "Fire Departments",
    icon: "Flame",
    blurb: "Readiness programs, accident-scene supplies and PFAS-free absorbents for first responders.",
    solutions: ["fire-dept", "spill-kit", "bonedry-all", "training", "custom"],
  },
  {
    name: "Public Works",
    icon: "Wrench",
    blurb: "Everyday spill readiness, stormwater management and facility cleaning for public operations.",
    solutions: ["spill-response", "stormwater", "bonedry-all", "cleaning", "spill-kit"],
  },
  {
    name: "Municipalities",
    icon: "Landmark",
    blurb: "Compliance-driven spill prevention and water management across municipal facilities.",
    solutions: ["spill-response", "stormwater", "compliance", "spill-kit", "cleaning"],
  },
  {
    name: "DOTs",
    icon: "TrafficCone",
    blurb: "Roadway spill response, site dewatering and soil stabilization for departments of transportation.",
    solutions: ["stormwater", "construction", "bonedry-all", "spill-response", "training"],
  },
  {
    name: "Manufacturing",
    icon: "Factory",
    blurb: "Shop-floor absorbents, cleaning chemistry and preparedness for continuous production.",
    solutions: ["spill-response", "bonedry-all", "cleaning", "spill-kit", "compliance"],
  },
  {
    name: "Chemical Plants",
    icon: "FlaskConical",
    blurb: "Caustic cleanup, hazardous-odor control and rigorous compliance support.",
    solutions: ["bonedry-sc", "spill-response", "compliance", "bonedry-all", "training"],
  },
  {
    name: "Food Processing",
    icon: "Utensils",
    blurb: "Sanitation-grade cleaning, safe absorbents and audit-ready compliance.",
    solutions: ["cleaning", "bonedry-all", "compliance", "spill-kit"],
  },
  {
    name: "Warehouses",
    icon: "Warehouse",
    blurb: "Spill readiness, fleet support and facility cleaning for high-throughput storage.",
    solutions: ["spill-response", "bonedry-all", "spill-kit", "fleet", "cleaning"],
  },
  {
    name: "Distribution Centers",
    icon: "Boxes",
    blurb: "Fleet programs and rapid response to keep goods moving safely.",
    solutions: ["fleet", "spill-response", "bonedry-all", "spill-kit"],
  },
  {
    name: "Trucking Companies",
    icon: "Truck",
    blurb: "Scheduled absorbent deliveries and fuel-spill products for fleets on the move.",
    solutions: ["fleet", "bonedry-all", "spill-response", "spill-kit"],
  },
  {
    name: "Construction Contractors",
    icon: "HardHat",
    blurb: "Mud control, wet-soil drying and daily site absorbent replenishment.",
    solutions: ["construction", "bonedry-all", "stormwater", "spill-kit"],
  },
  {
    name: "Marinas",
    icon: "Anchor",
    blurb: "Hydrocarbon absorbents and water management for waterfront environments.",
    solutions: ["bonedry-hc", "spill-response", "stormwater", "cleaning"],
  },
  {
    name: "Airports",
    icon: "Plane",
    blurb: "Fleet fueling support, rapid response and compliance for airfield operations.",
    solutions: ["fleet", "spill-response", "bonedry-all", "compliance", "cleaning"],
  },
  {
    name: "Railroads",
    icon: "TrainFront",
    blurb: "Hydrocarbon cleanup and preparedness along rail corridors and yards.",
    solutions: ["bonedry-hc", "spill-response", "bonedry-all", "spill-kit"],
  },
  {
    name: "Mining Operations",
    icon: "Pickaxe",
    blurb: "Water-based cuttings solidification, hydrocarbon control and site water management.",
    solutions: ["bonedry-h2o", "bonedry-hc", "stormwater", "spill-response", "custom"],
  },
];



export const footerLinks = [
  { label: "Drying Agent / Absorbent", path: "/absorbent" },
  { label: "Spill Solutions", path: "/spill-solutions" },
  { label: "Pinkwater®", path: "/pinkwater" },
  { label: "Cleaning Solutions", path: "/cleaning-solutions" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export const pinkwaterContent = {
  kicker: "Market Street Ventures",
  title: "Pinkwater® Surfactants",
  headline: "Advanced Surfactant Technology for Industrial Performance",
  headerImage:
    "https://images.pexels.com/photos/4883682/pexels-photo-4883682.jpeg?auto=compress&cs=tinysrgb&w=2000",
  lead:
    "Pinkwater® Surfactants are high-performance specialty formulations engineered to enhance industrial cleaning, hydrocarbon spill response, environmental remediation, and operational efficiency.",
  overview: [
    "Pinkwater was developed and introduced to the market over 30 years ago, and is highly regarded for its reliable performance and ease of use across a wide range of applications as a hydrocarbon mitigation agent.",
    "Pinkwater is a water-based formulation of nonionic surfactants and other specialty chemicals. Pinkwater contains no caustic, hydrocarbon solvents, d-limonene or any other hazardous or restricted ingredients.",
  ],
  stats: [
    { value: "30+", label: "Years of proven field performance" },
    { value: "Water-Based", label: "Nonionic surfactant formulation" },
    { value: "PFAS-Free", label: "Formulations available" },
  ],
  howIntro:
    "Pinkwater's strongly lipophilic (\u201coil-loving\u201d) surfactant formulation attacks hydrocarbon mitigation problems in two ways.",
  howSteps: [
    {
      number: "01",
      title: "Lowers Surface Tension",
      text: "First, it lowers the surface tension in liquids allowing easier spreading or \u201cwetting.\u201d This functional characteristic releases hydrocarbons from the surfaces they are adsorbed to, including soil particles, hard surfaces and fabrics.",
    },
    {
      number: "02",
      title: "Encapsulates Hydrocarbons",
      text: "Second, the surfactants in Pinkwater migrate to the surface of hydrocarbon droplets and, under the right conditions, encapsulate the oil droplet creating a micellar emulsion.",
    },
  ],
  fuelSpill: {
    title: "Trusted for Roadside Fuel Spills",
    text: "Pinkwater's initial success as a clean-up agent for roadside fuel spills resulted from its unique formulation as an emulsifier and hard surface cleaner. When applied to a fuel spill, Pinkwater encapsulates hydrocarbons, dramatically reducing vapor pressure and, when properly agitated, will make the spill non-flammable.",
  },
  applications: [
    "Hydrocarbon spill mitigation and cleanup",
    "Industrial equipment and facility cleaning",
    "Oil and fuel remediation",
    "Environmental restoration projects",
    "VOC suppression and vapor control",
    "Transportation, marine, aviation, and energy operations",
    "Municipal and emergency response applications",
  ],
  benefits: [
    "Breaks down and lifts petroleum-based contaminants",
    "Improves cleaning effectiveness while reducing labor and water usage",
    "Supports environmentally responsible remediation practices",
    "Compatible with a wide range of industrial cleaning systems",
    "PFAS-free formulations available for environmentally sensitive applications",
    "Proven performance across commercial, industrial, energy, and emergency response sectors",
  ],
  closing:
    "Engineered for Performance. Trusted in the Field 40+ years. Pinkwater® Surfactants deliver the cleaning power and environmental performance required by today's hydrocarbon industrial professionals — helping organizations improve safety, accelerate cleanup operations, and protect valuable assets while supporting regulatory compliance.",
  fieldApplications: [
    {
      icon: "Factory",
      title: "Offshore Platform Pressure Vessels",
      summary:
        "Decontaminate and degas production tanks prior to inspection so platforms return to service quickly.",
      points: [
        "After draining and cooling, a 6% Pinkwater solution in hot water is sprayed at 3,000 psi to suppress vapors and begin cleaning.",
        "Once LELs are lowered, tanks are safely opened and vented; final desludging is completed open with the same 6% solution at 3,000 psi.",
        "Sludge (typically oil, brine and sand) is removed on-site or offsite for separation, allowing inspection, maintenance and rapid return to service.",
      ],
    },
    {
      icon: "Droplets",
      title: "Cleaning & Degassing Under the Tank",
      summary:
        "Neutralize hydrocarbon vapors from tank-bottom leaks that keep LELs above safe limits.",
      points: [
        "Pinkwater solution is injected into the sand beneath the tank to emulsify hydrocarbons and suppress vapors, often through nozzles set around the leak.",
        "This frequently eliminates the vapor source and reduces LELs to safe levels for hot work and manned entry.",
        "For larger leaks, an injection-and-extraction operation can decontaminate the sand, depending on the tank-bottom configuration and drain/leak-detection system.",
      ],
    },
    {
      icon: "Layers",
      title: "Sludge Cleaning & Solids Recovery",
      summary:
        "Clean sludge solids on-site to avoid the cost of transporting and disposing of hazardous waste.",
      points: [
        "Sludge is circulated with cutter stocks as needed, then a side stream is batched to a frac tank where hydrocarbons are drawn off the top for reprocessing.",
        "Pinkwater concentrate is added to the aqueous mixture and aggressively mixed, stripping hydrocarbons from the solids into an emulsion.",
        "After separation: clean solids settle out (potential clean fill), water goes to industrial wastewater treatment, and the top emulsion layer — up to ~99% of the hydrocarbons — is skimmed and handled as hazardous waste.",
      ],
    },
  ],
};
